// 设置URL查询参数
export const setQuery = ({ url = window.location.href, list = [], force = false }) => {
    let resultUrl = url;

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        list.forEach(item => {
            const { key, value } = item;

            if (force) {
                searchParams.set(key, value);
            } else if (!searchParams.has(key)) {
                searchParams.append(key, value);
            }
        });

        resultUrl = urlObj.href;
    } catch (e) {
        console.error(e);
    }

    return resultUrl;
};

// 获取URL查询参数
export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 设置URL在客户端的标准查询参数
export const setAppQuery = url => {
    return setQuery({
        url,
        list: [{ key: 'isFull', value: '0' }, { key: 'immersion', value: 'true' }, { key: 'ifengsp', value: '1' }],
    });
};
